export default "__VITE_ASSET__CrWwG4Mn__"